<template>
  <div>
    <the-nav-bar :title="$t('customerManagement.blacklist')" />
    <div class="body-wrapper">
      <md-field :brief="$t('customerManagement.addToList')">
        <md-input-item
          title="Mixin ID"
          v-model.trim="value"
          type="digit"
          align="right"
          maxlength="10"
          :placeholder="$t('customerManagement.inputPlaceholder')"
        ></md-input-item>
        <div class="btn-wrapper" slot="footer">
          <md-button
            :type="btnDisabled ? 'disabled' : 'primary'"
            @click="onSubmit"
          >
            <div class="row-center">
              <svg class="icon">
                <use xlink:href="#icon-add" />
              </svg>
              <span>{{ $t('customerManagement.add') }}</span>
            </div>
          </md-button>
        </div>
      </md-field>
      <div class="scroll-wrapper" v-if="list.length">
        <md-scroll-view
          ref="scrollView"
          :scrolling-x="false"
          auto-reflow
          @end-reached="onReachEnd"
        >
          <div class="scroll-body">
            <div
              class="scroll-item row-align-center"
              v-for="item in list"
              :key="item.mixinId"
            >
              <div class="avatar row-center">
                <img :src="item.avatar" class="avatar-img" />
              </div>
              <div class="info col">
                <span class="name">{{ item.nickname }}</span>
                <span class="mixin-id">{{ item.mixinId }}</span>
              </div>
              <div class="action">
                <md-button
                  :type="removingId == item.id ? 'disabled' : 'primary'"
                  plain
                  round
                  @click="onRemoveItemClicked(item)"
                  :loading="removingId == item.id"
                >
                  <div class="row-center" v-show="removingId !== item.id">
                    <svg class="icon-remove">
                      <use xlink:href="#icon-remove" />
                    </svg>
                    <span>{{ $t('customerManagement.remove') }}</span>
                  </div>
                </md-button>
              </div>
            </div>
          </div>
          <md-scroll-view-more
            slot="more"
            :is-finished="isFinished"
            :loading-text="$t('common.loading')"
            :finished-text="$t('common.noMore')"
          ></md-scroll-view-more>
        </md-scroll-view>
      </div>
    </div>
  </div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import {
  Field,
  InputItem,
  Button,
  ScrollView,
  ScrollViewMore,
  Toast,
  Dialog,
} from 'mand-mobile';

import { getUserList, postAddToList, deleteFromList } from '@/api/user';
export default {
  components: {
    TheNavBar,
    [Field.name]: Field,
    [InputItem.name]: InputItem,
    [Button.name]: Button,
    [ScrollView.name]: ScrollView,
    [ScrollViewMore.name]: ScrollViewMore,
  },
  data() {
    return {
      value: '',
      page: 1,
      perPage: 20,
      list: [],
      isFinished: false,
      isLoading: false,
      removingId: null,
      isSubmitting: false,
    };
  },
  computed: {
    btnDisabled() {
      return this.isSubmitting || this.value.length < 5;
    },
  },
  mounted() {
    this.refresh();
  },
  methods: {
    onReachEnd() {
      if (this.isFinished || this.isLoading) return;
      this.loadMore()
        .then(data => {
          if (!data.links || !data.links.next) {
            this.isFinished = true;
          }
          this.$refs.scrollView && this.$refs.scrollView.finishLoadMore();
        })
        .catch(err => {
          Toast.failed(err.message);
        });
    },
    loadMore(isRefresh = false, isScrollToTop = false) {
      this.isLoading = true;
      if (isRefresh) {
        this.page = 1;
        this.isFinished = false;
      }
      return getUserList(this.page, this.perPage, '0')
        .then(data => {
          const d = data.data;
          const arr = [];
          if (Array.isArray(d)) {
            d.forEach(item => {
              arr.push({
                id: item.id,
                avatar:
                  item.avatarUrl || require('@/images/avatar-default.svg'),
                nickname: item.userName,
                mixinId: item.mixinId,
              });
            });
          }
          this.list = isRefresh ? arr : this.list.concat(arr);
          this.page += 1;
          this.$refs.scrollView && this.$refs.scrollView.reflowScroller();
          if (isScrollToTop) {
            this.$refs.scrollView && this.$refs.scrollView.scrollTo(0, 0, true);
          }
          this.isLoading = false;
          return Promise.resolve(data);
        })
        .catch(err => {
          this.isLoading = false;
          return Promise.reject(err);
        });
    },
    onRemoveItemClicked(item) {
      const index = this.list.indexOf(item);
      this.removingId = item.id;
      deleteFromList(item.id)
        .then(() => {
          this.removingId = null;
          this.list.splice(index, 1);
          Toast.succeed(this.$t('customerManagement.removeSuccessfully'));
        })
        .catch(err => {
          this.removingId = null;
          Toast.failed(err.message);
        });
    },
    onSubmit() {
      this.isSubmitting = true;
      postAddToList(this.value, 0)
        .then(() => {
          this.isSubmitting = false;
          this.value = '';
          Toast.succeed(this.$t('customerManagement.addSuccessfully'));
          this.refresh();
        })
        .catch(err => {
          this.isSubmitting = false;
          Dialog.alert({
            icon: 'warn-color',
            title: err.message,
            confirmText: this.$t('common.confirm'),
          });
        });
    },
    refresh() {
      this.loadMore(true, true)
        .then(data => {
          if (!data.links || !data.links.next) {
            this.isFinished = true;
          }
          this.$refs.scrollView && this.$refs.scrollView.finishLoadMore();
        })
        .catch(err => {
          Toast.failed(err.message);
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
.body-wrapper {
  position: absolute;
  absolute-pos(11.73vw);
  display: flex;
  flex-direction: column;

  .md-scroll-view-more {
    padding-bottom: 15vw;
  }
}

.md-field {
  position: relative;
  flex-shirnk: 0;
  hairline(bottom);

  .btn-wrapper {
    margin-top: 7.47vw;

    .icon {
      margin-right: 1.07vw;
      width: 4.8vw;
      height: 4.8vw;
    }
  }

  & >>> {
    .md-field-item-content {
      &:before {
        content: none;
      }
    }

    .md-field-item-title {
      width: 32vw;
      font-size: 3.73vw;
    }

    .md-input-item-input {
      width: 53.6vw;
      padding: 0 2.13vw;
      border: 0.27vw solid #eaf1f3;
      border-radius: 2.67vw;
      background: #f8f8fc;
    }
  }
}

.scroll-wrapper {
  position: relative;
  flex: 1 0 0;

  .md-scroll-view {
    position: absolute;
    absolute-pos();
  }
}

.scroll-item {
  margin: 2.13vw 4.8vw 0;
  padding: 4.8vw;
  border: 0.27vw solid #eaf1f3;
  border-radius: 2.67vw;
  background: #fff;

  .avatar {
    box-sizing: border-box;
    flex: 0 0 10.67vw;
    height: 10.67vw;
    border: 0.27vw solid #eaf1f3;
    border-radius: 2.67vw;
    overflow: hidden;

    .avatar-img {
      width: 100%;
    }
  }

  .info {
    margin-left: 2.13vw;
    flex: 1 0 0;

    .name {
      font-size: 3.73vw;
    }

    .mixin-id {
      font-size: 2.67vw;
      color: color-text-caption;
    }
  }

  .action {
    flex: 0 0 26.67vw;

    .md-button {
      height: 9.6vw;
      line-height: 9.6vw;

      &:active {
        background: rgba(color-primary, 0.15);
      }

      & >>> {
        .md-activity-indicator-svg {
          margin-right: 0;
        }
      }
    }

    .icon-remove {
      margin-right: 1.07vw;
      width: 4.8vw;
      height: 4.8vw;
    }
  }
}
</style>
